import React from "react";
import VideoUpload from "./VideoUpload";
import VideoListPlayer from "./VideoListPlayer";

const RecodingAndMap = ({ data }) => {
  localStorage.setItem("surveyId", data?._id);
  return (
    <div className="flex flex-col gap-4">
      <div className="flex justify-between items-center">
        <VideoUpload surveyId={data?._id} />
        {/* <div hidden className="space-x-4 gap-4">
          <button className="bg-[#063269] text-white px-8 py-2 rounded-3xl">
            Map
          </button>
          <button className="bg-[#063269] text-white px-8 py-2 rounded-3xl">
            Start Recording
          </button>
        </div> */}
      </div>

      <div>
        <VideoListPlayer surveyId={data?._id} />
      </div>
    </div>
  );
};

export default RecodingAndMap;
